import PropTypes from 'prop-types';

export default function Description({ children }) {
  return (
    // <div className="collapse mb-5 mt-4 pl-7 pr-5 pt-3 pb-4 bg-neutral-50 border-neutral-300 shadow-sm bordered border-t border-r border-b before:absolute before:h-full before:w-[10px] before:bg-neutral-800">
    <div className="mb-5 mt-4 pl-5 pr-5 border-l-4 border-neutral-300">
      <div className="flex flex-col">
        <div className="font-medium text-md">
          <p className="pb-4 text-lg underline underline-offset-[5px] decoration-2 font-extrabold">
            Overview
          </p>
          {children}
        </div>
      </div>
    </div>
  );
}

Description.propTypes = {
  children: PropTypes.node,
};
